<template>
  <div class="wrap">
    <div class=" top fs32">
      <h3 v-if="type != 18 && type != 24">阀门 {{ no }} 登录日志</h3>
      <div v-else class="tabs">
        <van-tabs v-model="activeTabs" @change="handleClick">
          <van-tab title="登录日志" name="1"></van-tab>
          <van-tab title="操作日志" name="2"></van-tab>
          <van-tab title="故障日志" name="3"></van-tab>
          <van-tab v-if="type == 18 || type == 24" title="灌溉统计" name="4">
          </van-tab>
        </van-tabs>
      </div>
    </div>

    <van-grid v-if="activeTabs == 4" :column-num="3">
      <van-grid-item text="编号" />
      <van-grid-item text="总时长/年" />
      <!-- <van-grid-item text="最新" /> -->
      <van-grid-item text="时长" />
    </van-grid>

    <div :class="['part1', activeTabs == 4 && 'part4']">
      <div>
        <van-pull-refresh class="pull-refresh" v-model="isLoading" @refresh="onRefresh">
          <div v-if="activeTabs < 4 && !list.length"
            :style="{ display: 'flex', alignItems: 'center', margin: '20px', justifyContent: 'center', height: '30vh' }">
            暂无数据
          </div>

          <div v-else-if="activeTabs == 4 && !irrigationData.length"
            :style="{ display: 'flex', alignItems: 'center', margin: '20px', justifyContent: 'center', height: '30vh' }">
            暂无数据
          </div>

          <van-list v-else v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="true"
            @load="onLoad">
            <template v-if="activeTabs != 4">
              <van-cell v-for="(item, index) in list" :key="index">
                <div :style="{ marginRight: '20px' }">{{ index + 1 }}</div>
                <div :style="{ flex: 2 }">{{ item.createTime }}</div>
                <div :style="{ color: item.remark === '断开' && 'red', 'flex': 3 }" class="logRemark"> {{ item.remark }}
                </div>
              </van-cell>
            </template>

            <template v-else>
              <van-grid v-for="(item, index) in irrigationData" :key="index" :column-num="3">
                <van-grid-item>
                  <a :style="{ color: '#4994df' }" @click="handleValvaDetail(item)"> {{ item.portName }} </a>
                </van-grid-item>
                <van-grid-item :text="item.totalDurationDesc" />
                <!-- <van-grid-item text="123" /> -->
                <van-grid-item :text="item.monthDurationDesc" />
              </van-grid>
            </template>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>

    <!-- 设备信息 -->
    <div class="part2 fs28" v-if="activeTabs != 4">
      <div class="top fs32">
        <h3>设备信息</h3>
      </div>
      <div class="info">
        <div class="item deviceName" :style="{ display: 'flex', alignItems: 'center' }">
          <span>设备名称：</span> <span :style="{ display: 'flex', alignItems: 'center' }">{{ deviceName }} <van-button
              @click="() => (visible = true)"
              :style="{ background: '#1989fa', color: '#fff', height: '24px', marginLeft: '4px' }">修改</van-button> </span>
        </div>

        <div class="item" v-for="item in data" :key="item.key">
          {{ item.label }}： {{ item.value || 'null' }} {{ item.unit }}
        </div>
      </div>
      <!-- 去绑定RTU设备 -->
      <div class="btn" v-if="showBtn">
        <van-button v-if="type == 20" class="orangeToYellow threbtn" @click.stop="handleToBindCgq"> 去绑定传感器</van-button>
        <van-button v-else class="orangeToYellow threbtn" @click.stop="handleToBind">去绑定RTU设备</van-button>
      </div>

      <van-dialog v-model="visible" title="修改设备名称" show-cancel-button @confirm="handleChangeName"
        @cancel="() => (visible = false)">
        <van-field v-model="newDeviceName" placeholder="请输入新的设备名称" maxlength="50" type="textarea" show-word-limit />
      </van-dialog>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  data () {
    return {
      list: [],
      page: 1,
      pageSize: 30,
      paegs: 0,
      isLoading: false,
      loading: false,
      finished: false,
      no: "",
      isFirst: false,
      data: [
        {
          key: "lat",
          label: "经度",
          value: "",
        },
        {
          key: "lon",
          label: "纬度",
          value: "",
        },
        {
          key: "signal",
          label: "信号强度",
          value: "",
          unit: "dbm",
        },
        {
          key: "vol",
          label: "电压",
          value: "",
          unit: "V",
        },
        {
          key: "volSolar",
          label: "太阳能电压",
          value: "",
          unit: "V",
        },
        {
          key: "gprsNum",
          label: "网卡号码",
          value: "",
          unit: "",
        }, {
          key: "software_version",
          label: "软件版本",
          value: "",
          unit: "",
        }, {
          key: "hardware_version",
          label: "硬件版本",
          value: "",
          unit: "",
        },
        {
          key: "channel",
          label: "信道",
          value: "",
          unit: "",
        }
      ],
      rtuNo: null,
      activeTabs: 1,
      type: null,
      showBtn: true,
      deviceInfo: null,
      visible: false,
      deviceName: null,
      newDeviceName: null,
      irrigationData: [], // 灌溉统计的数据
    };
  },

  async created () {
    const query = this.$route.query;
    this.no = localStorage.getItem("no");
    this.type = sessionStorage.getItem("deviceType")
    this.rtuNo = query.rtuNo;


    if (this.type == 1 || this.type == 2 || this.type == 7) {
      this.showBtn = false
    }

    this.onRefresh();

    await this.getDeviceInfo();


    if (this.deviceInfo?.coordinate === "GPS") return

    const str = this.data[0].value.slice(1);
    const str2 = this.data[1].value.slice(1);

    const latD = this.pointIndexOf(str).t;
    const lngD = this.pointIndexOf(str2).t;
    const latM = this.pointIndexOf(str).g;
    const lngM = this.pointIndexOf(str2).g;

    const _latM = latM / 60;
    const _lngM = lngM / 60;

    const lat = (Number(latD) + Number(_latM)).toFixed(5);
    const lng = (Number(lngD) + Number(_lngM)).toFixed(5);

    this.data[0].value = lng;
    this.data[1].value = lat;
  },

  methods: {
    // 读取所有阀门信息
    async getDeviceInfo () {

    },

    async handleChangeName () {
      await this.$api.updateDeviceInfo({ "gatewayName": this.newDeviceName, "gatewayNo": this.no, }).then((res) => {
        if (res.errcode === 0) {
          this.$toast.success({ message: "更新成功" })
          this.visible = false
          setTimeout(() => {
            window.location.reload()
          }, 1000)
        } else {
          this.$toast({
            message: `更新失败:${res.errmsg}`
          })
        }
      })

    },

    handleClick (index) {

      this.activeTabs = index
      this.page = 1
      this.list = []
      this.pages = 1
      this.finished = false
      this.onLoad()
    },

    pointIndexOf (str) {
      const index = str.indexOf(".");
      const t = str.slice(0, index - 2);
      const g = str.slice(index - 2);

      return { t, g };
    },

    // 查询日志
    async getList () {
      const { page, pageSize } = this;
      const fn = this.activeTabs == 1 ? 'getGatewayLoginLog' : this.activeTabs == 2 ? "irrigationGroupLogOpList" : "irrigationGroupLogFailList"

      await this.$api[fn]({ gatewayNo: this.no, page, pageSize, }).then((res) => {
        if (res.errcode === 0 && res?.list?.length) {
          res.list.map(item => {
            if (typeof item.createTime == "number") {
              item.createTime = moment(new Date(item.createTime)).format("YYYY-MM-DD HH:mm:ss")
            }
          })
          this.list = this.list.concat(res.list);
          this.page++;
          this.isFirst = true;
          let pages = res.pages
          if (!pages) {
            pages = Math.floor(res.total / res.pageSize)
            if (res.total % res.pageSize !== 0) {
              pages += 1
            }
          }
          this.pages = pages

          if (this.pages == 0) {
            this.finished = true
          }
          this.$toast.clear()
        } else {
          this.list = [...this.list.concat([])];
          this.finished = true
          this.isLoading = false
          this.isFirst = false;
          this.paegs = 1
          this.page = 2
          this.$toast("查询" + (this.activeTabs == 1 ? '登录' : this.activeTabs == 2 ? '操作' : '故障') + "日志异常:" + res.errmsg)
        }
      });
    },

    // 跳转去灌溉统计页面
    handleValvaDetail (data) {
      this.$router.push({ path: '/irrigationStaticLog', query: { data: JSON.stringify(data) } })
    },

    async getIrrigationData () {
      await this.$api.getStatisticByMonth({ gatewayNo: this.no, year: new Date().getFullYear() }).then((res) => {
        if (res.errcode != 0) return this.$toast("查询灌溉统计异常:" + res.errmsg)
        const data = [...res.data]
        // 需要将所有数据中的 channelNo 进行统计总时长
        const times = {}
        data.map(item => {
          if (times[item.channelNo] != null) {
            times[item.channelNo] += item.durationSum
          } else {
            times[item.channelNo] = item.durationSum
          }
        })

        data.map(item => {
          // 总时长
          item.totalDurationDesc = this.durationDesc(times[item.channelNo])
          item.monthDurationDesc = this.durationDesc(item.durationSum)
        })


        this.irrigationData = [...data]
        // 这里是为了阻止滚动组件疯狂翻页请求
        this.finished = true
        this.isLoading = false
        this.isFirst = false;
        this.paegs = 1
        this.page = 2
        this.$toast.clear()
      })
    },

    durationDesc (time) {
      const second = 1
      const minus = 60 * second
      const hour = 60 * minus
      if (time < hour) return `${(time / minus).toFixed(1)}分`
      return `${(time / hour).toFixed(1)}时`
    },


    // 请求设备属性信息
    async getDeviceInfo () {
      await this.$api.getGatewayInfo({ gatewayNo: this.no, }).then((res) => {
        const data = res.data;
        const version = data.version
        if (version) {
          data.software_version = version.substr(0, 6)
          data.hardware_version = version.substr(6)
        }
        this.data.map((item) => {
          item.value = data[item.key];
        });

        this.deviceInfo = { ...data }
        this.newDeviceName = data.deviceName
        this.deviceName = data.deviceName;
      });
    },

    // 下拉请求数据
    async onRefresh () {
      console.log("onRefreshonRefreshonRefreshonRefresh");

      this.list = [];
      this.isLoading = true;
      this.page = 1;
      await this.getData();
      this.isLoading = false;
    },

    // 下滑请求数据
    async onLoad () {
      this.loading = true;
      if (this.isFirst) {
        await this.getData()
      } else if (this.pages === 0) {
        return
      } else {
        this.page <= this.pages && (await this.getData());
      }
      this.loading = false;

      if (this.page > this.pages) {
        this.finished = true;
      } else {
        this.finished = false;
      }
    },


    async getData () {
      this.$toast.loading('数据加载中')
      if (this.activeTabs < 4) {
        await this.getList();
      } else {
        // 灌溉统计信息
        await this.getIrrigationData()
      }
    },

    // 去绑定RTU设备
    handleToBind () {
      console.log(this.rtuNo);
      console.log(this.no);
      // RTU_id  网关id
      window.location.href = window.location.origin + `/addEquip?rtuId=${this.rtuNo}&wgId=${this.no}`
    },
    handleToBindCgq () {
      window.location.href = window.location.origin + `/addCgq?rtuId=${this.rtuNo}&wgId=${this.no}`
    }
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  height: 100%;
  overflow: hidden;
}

.top {
  width: 100%;
  height: 60px;
  line-height: 60px;
  color: #ffffff;
  background: linear-gradient(90deg,
      rgba(53, 105, 233, 0.9) 0%,
      rgba(24, 76, 204, 1) 100%) !important;

  a {
    color: #ffffff;
    margin-right: 20px;
  }


  h3 {
    padding-left: 15px;
  }
}


.part1 {
  position: absolute;
  top: 60px;
  left: 0;
  width: 100%;
  height: 50%;
  overflow-y: scroll;

  .pull-refresh {
    height: 100%;
    font-size: 14px;
  }

  /deep/ .van-cell__value {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}


.part4 {
  height: calc(100% - 110px);
  top: 110px;

  ::v-deep .van-grid-item__content {
    padding: 6px 8px;
  }
}


/deep/ .van-tabs__nav {
  background: linear-gradient(90deg,
      rgba(53, 105, 233, 0.9) 0%,
      rgba(24, 76, 204, 1) 100%) !important;
}

/deep/ .van-tab {
  color: #ffffff;
  font-size: 16px;
}

/deep/ .van-tabs__line {
  background-color: #ffffff;
  bottom: 22px;
}

/deep/ .van-tabs__wrap {
  height: 54px;
}

.part2 {
  position: absolute;
  bottom: 0;
  left: 0;
  height: calc(50% - 60px);
  box-sizing: border-box;

  .info {
    display: flex;
    flex-wrap: wrap;
    padding: 16px;
  }

  .item {
    width: 50%;
    min-height: 24px;
    padding-bottom: 10px;
  }
}

.btn {
  width: 100%;
  margin-top: 20px;
  text-align: center;

  button {
    border-radius: 0.1rem;
    width: 90%;
    height: 56px;
    color: #ffffff;
    font-size: 16px;
  }
}

.logRemark {
  flex: 1;
  flex-wrap: wrap;
}

.deviceName {
  width: 100% !important;
}

::v-deep .van-dialog__content {
  height: 100px;
}

::v-deep .van-cell__value {
  height: 90%;
}

::v-deep .van-grid-item__text {
  font-size: 14px;
}
</style>
